/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import listenForClick from "./clickHandler";

//Copy from:
//https://code.iamkate.com/javascript/collapsible-lists/

/*

CollapsibleLists.js

An object allowing lists to dynamically expand and collapse

Created by Kate Morley - http://code.iamkate.com/ - and released under the terms
of the CC0 1.0 Universal legal code:

http://creativecommons.org/publicdomain/zero/1.0/legalcode

*/

export function makeCollapsibleLists(node : HTMLElement){
    if (!node)
        return;

    let allLiEles = node.querySelectorAll("li");
    allLiEles.forEach(_liEle => {
        let liEle = _liEle as HTMLElement;
        if (liEle.querySelectorAll("ul").length > 0){
            let toggleButton = document.createElement('div');
            toggleButton.classList.add("mi-toggle");
            liEle.appendChild(toggleButton);

            listenForClick(toggleButton, () => {
                liEle.classList.toggle("mi-close");
            });
        }
    });
}
